export default __webpack_public_path__ + "static/media/message-away.b28ef96b.png";